import { useStore } from "vuex";
import { computed } from "vue";

/**
 * 查询国际化语言
 * @param code 定义的code
 * @return {text} 返回对应语言的文本
 */
export function useRemoteI18n(code) {
  const store = useStore();
  const i18nText = computed(() => {
    let findItem = store.state.siteSetting.find((el) => el.paramCode === code);
    if (!findItem) return "";
    let findSiteConfig = (findItem.content || []).find(
      (el) => el.siteCode === store.state.siteCode
    );
    if (!findSiteConfig) return "";
    return findSiteConfig.text;
  });
  return i18nText.value;
}
